function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { genStyleUtils } from '@ant-design/cssinjs-utils';
import { ConfigContext } from '../../config-provider/context';
import { genCommonStyle, genLinkStyle } from '../../style';
import useLocalToken, { unitless } from '../useToken';
import useResetIconStyle from './useResetIconStyle';
var _genStyleUtils = genStyleUtils({
    usePrefix: function usePrefix() {
      var _useContext = useContext(ConfigContext),
        getPrefixCls = _useContext.getPrefixCls,
        iconPrefixCls = _useContext.iconPrefixCls;
      var rootPrefixCls = getPrefixCls();
      return {
        rootPrefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls
      };
    },
    useToken: function useToken() {
      var _useLocalToken = useLocalToken(),
        _useLocalToken2 = _slicedToArray(_useLocalToken, 5),
        theme = _useLocalToken2[0],
        realToken = _useLocalToken2[1],
        hashId = _useLocalToken2[2],
        token = _useLocalToken2[3],
        cssVar = _useLocalToken2[4];
      return {
        theme: theme,
        realToken: realToken,
        hashId: hashId,
        token: token,
        cssVar: cssVar
      };
    },
    useCSP: function useCSP() {
      var _useContext2 = useContext(ConfigContext),
        csp = _useContext2.csp,
        iconPrefixCls = _useContext2.iconPrefixCls;
      // Generate style for icons
      useResetIconStyle(iconPrefixCls, csp);
      return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: function getResetStyles(token) {
      return [{
        '&': genLinkStyle(token)
      }];
    },
    getCommonStyle: genCommonStyle,
    getCompUnitless: function getCompUnitless() {
      return unitless;
    }
  }),
  genStyleHooks = _genStyleUtils.genStyleHooks,
  genComponentStyleHook = _genStyleUtils.genComponentStyleHook,
  genSubStyleComponent = _genStyleUtils.genSubStyleComponent;
export { genStyleHooks, genComponentStyleHook, genSubStyleComponent };